import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { showSpinner, hideSpinner, navigationEnd, navigationStart } from './navigation.actions';
import { tap } from 'rxjs/operators';

@Injectable()
export class NavigationEffects {
    constructor(
        private actions$: Actions
    ) { }

    showSpinner$ = createEffect(() =>
        this.actions$.pipe(
            ofType(showSpinner),
            tap(action => {
                return action.response;
            })
        ), { dispatch: false }
    );


    hideLoader$ = createEffect(() =>
        this.actions$.pipe(
            ofType(hideSpinner),
            tap(action => {
                return action.response;
            })
        ), { dispatch: false }
    );

    navigationStart$ = createEffect(() =>
        this.actions$.pipe(
            ofType(navigationStart),
            tap(action => {
                return action.response;
            })
        ), { dispatch: false });

    navigationEnd$ = createEffect(() =>
        this.actions$.pipe(
            ofType(navigationEnd),
            tap(action => {
                return action.response;
            })
        ), { dispatch: false });

}
